import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CartService } from '@services/cart.service';
import { Product, ProductAttribute } from '@interfaces/product';
import { WishlistService } from '@services/wishlist.service';
import { CompareService } from '@services/compare.service';
import { QuickviewService } from '@services/quickview.service';
import { RootService } from '@services/root.service';
import { CurrencyService } from '@services/currency.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Products } from '@app/_models';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/_services/authentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { QuickviewComponent } from '../quickview/quickview.component';
import { UntypedFormControl } from '@angular/forms';
import { DirectionService } from '@app/_services/direction.service';
import { SharedService } from '@app/_services/shared.service';
import { TranslateHelper } from '@app/_helpers';
import { CurrencyFormatPipe } from '../../pipes/currency-format.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { EventCollectorDirective } from '../../../_directives/events-collector/events.collector';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { RouterLink } from '@angular/router';
import { ClickDirective } from '../../directives/click.directive';
import { OwlPreventClickDirective } from '../../directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgIf, NgFor, NgStyle, UpperCasePipe, KeyValuePipe } from '@angular/common';

@Component({
    selector: 'app-product-property-card',
    templateUrl: './product-property-card.component.html',
    styleUrls: ['./product-property-card.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, CarouselModule, OwlPreventClickDirective, NgFor, ClickDirective, RouterLink, NgStyle, ExtendedModule, EventCollectorDirective, UpperCasePipe, KeyValuePipe, TranslateModule, CurrencyFormatPipe]
})
export class ProductPropertyCardComponent implements OnInit {

    constructor(
        public root: RootService,
        public cart: CartService,
        public wishlist: WishlistService,
        public compare: CompareService,
        public quickview: QuickviewService,
        public currency: CurrencyService,
        private toastr: ToastrService,
        private authenticationService: AuthenticationService,
        private modalService: BsModalService,
        private direction: DirectionService,
        private sharedService:SharedService,
        public translateHelper: TranslateHelper
    ) { }

    private destroy$: Subject<void> = new Subject();

    @Input() product: any;
    @Input() layout: 'grid-sm' | 'grid-nl' | 'grid-lg' | 'list' | 'horizontal' | null = null;

    addingToCart = false;
    _=_;

    showingQuickview = false;
    featuredAttributes: ProductAttribute[] = [];
    imageKey;
    image = 'assets/images/nologo.png';
    userDetails;
    discountedPrice;
    discountedRate;

    modalRef: BsModalRef;

    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;

    amount = new UntypedFormControl(1);
    isQuotable;
    sector;
    addToCartAndQuotation;
    companyData;
    options = {
        nav: false,
        dots: true,
        autoHeight:false,
        skip_validateItems: true,
        loop: true,
        lazyLoad: true,
        autoplay: false,
        responsive: {
            0: { items: 1 }
        },
        rtl: this.direction.isRTL()
    };

    checkIfQuotation() {
        if (this.product.minQuotationAmount == 0) {
            this.isQuotable = false;
            this.addToCartAndQuotation = false;
        } else if (
            this.product.minQuotationAmount > 0 &&
            !this.product.allowAddToCartWithQuotation
        ) {
            this.isQuotable = true;
            this.addToCartAndQuotation = false;
        } else if (
            this.product.minQuotationAmount > 0 &&
            this.product.allowAddToCartWithQuotation
        ) {
            this.isQuotable = true;
            this.addToCartAndQuotation = true;
        }
    }
    ///view add to cart button or if false show View item button
    ///item must be of type product not service and has no options, Moreover
    ///must not be quotable
    viewAddtoCart() {
        //if(this.product.type == 'product' && !this.product.options) && !(this.isQuotable && !this.addToCartAndQuotation)

        //return this.product.type == 'product' && !this.product.options && !(this.isQuotable && !this.addToCartAndQuotation);

        if (this.product.isOfferable) {
            return false;
        }

        if (this.product.type == 'product' && !this.product.options)
            if (this.isQuotable) {
                return this.addToCartAndQuotation;
            } else {
                return true;
            }
        return false;

    }


    ngOnInit(): void {
        this.companyData=this.product?.companyData?.[0];
        this.sharedService.page$.subscribe(page => (this.sector = page));
        this.checkIfQuotation();
        if (
            this.product?.discountValue?.value &&
            this.product?.discountValue.type != 'N'
        ) {
            this.discountedPrice =
                this.product?.discountValue.type == 'F'
                    ? this.product.taxedPrice || this.product.price - this.product.discountValue?.value
                    : this.product.taxedPrice || this.product.price -
                    (this.product.discountValue?.value * this.product.taxedPrice || this.product.price) /
                    100;
            let oldPrice = this.product.baseTaxedPrice ? this.product.baseTaxedPrice : this.product.price;
            this.discountedRate = _.round((oldPrice - this.discountedPrice) / oldPrice * 100, 0);
        }

        if (this.product?.images)
            this.imageKey = Object.keys(this.product.images)[0]?.toString();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    addToCart(): void {
        if (!this.addingToCart) {
            this.addingToCart = true;

            this.cart.addItem({ productId: this.product._id, amount: this.amount.value },this.product).subscribe(
                (response) => {
                    if (response.code == 200)
                        this.toastr.success(`Product "${this.product.name?.en}" added to cart!`);
                    else
                        this.toastr.error(response.msg);
                    this.addingToCart = false;
                }, (error) => {
                    this.toastr.error('Error adding to cart.');
                    this.addingToCart = false;
                });
        }
    }

    showQuickview(): void {
        let initialState = { product: this.product }
        this.modalRef = this.modalService.show(this.template, { initialState })
    }

    routerLinkString() {
        return [...(this.product.sector?.seo?.slug) ? ['/sector', this.product.sector?.seo?.slug] : '/', this.product?.layout || this.product?.type, this.product?.seo?.slug];
    }

}
